
import React, {useState} from 'react';
import 'stylesheets/fonts.scss';
import 'stylesheets/colors.scss';
import 'stylesheets/layout.scss';
import 'stylesheets/ConfirmModal.scss';
import text from 'strings/text';
import { injectIntl } from 'react-intl';

export function RemoveUserModal({ removeUser, closeModal, name }) {

const [isConfirmEnabled, setIsConfirmEnabled] = useState(false);

    const handleCancel = (event) => {
        closeModal();
    }
    const handleConfirm = (event) => {
        if( isConfirmEnabled == true) {
            removeUser();
            closeModal();
        }
    }

    const handleInputChange = (event) => {
        const inputValue = event.target.value;
        if (inputValue.toLowerCase() == 'remove') {
            setIsConfirmEnabled(true);
        } else {
            setIsConfirmEnabled(false);
        }
    }

    return (
        <div className="confirm-modal-container">
            <label className="title-text">{text.removeUserTitle(name)}</label>
            <div className='body-text1 fs14'>{text.removeUserExplain}</div>
            <input className='body-input' type='text' onChange={handleInputChange}/>

            <div className="confirm-button-wrap">
                <button className="confirm-button-cancel" onClick={handleCancel}>{text.cancel}</button>
                <button className={`confirm-button ${isConfirmEnabled ? 'button-enabled' : 'button-disabled'}`} onClick={handleConfirm}>{text.confirm}</button>
            </div>
        </div>
    )
}

export default injectIntl(RemoveUserModal);